import React from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'reactstrap'
import Item from './item'
import { fontWeight } from 'themes/font'
import breakPoints from 'themes/breakPoints'

const Section = styled.section``

const List = styled(Row)`
  @media (max-width: ${breakPoints.md.max}px) {
    padding-bottom: 48px;
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    border-bottom: 2px solid #abd8fb;
    padding-bottom: 80px;
  }
`

const Heading = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 80px;
  h1 {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 30px;
    font-weight: ${fontWeight.medium};
    background: #ffffff;
    box-shadow: 0 0 18px 0 #abd8fb;
    display: inline-block;
    padding: 8px 24px;
    border-radius: 8px;
  }
  .line {
    flex: 1;
    height: 2px;
    background-color: #abd8fb;
  }
  @media (max-width: ${breakPoints.md.max}px) {
    margin-bottom: 16px;
    h1 {
      font-size: 1.5rem;
    }
  }
`

const OurValues = ({ data: { heading, values } }) => {
  return (
    <Section className='wow fadeIn'>
      <Container>
        <Heading>
          <span className='line' />
          <h1>{heading}</h1>
          <span className='line' />
        </Heading>
        <List>
          {values.map((value, index) => (
            <Col xs={6} lg={4}>
              <Item key={index} {...value} />
            </Col>
          ))}
        </List>
      </Container>
    </Section>
  )
}

export default OurValues
